


import localeSettings from './zh-CN/settings';
import localeLogin from '@/views/desktop/Login/locale/zh-CN';
import localeEmailLogin  from '@/views/desktop/emailLogin/locale/zh-CN';
import localeLayout from '@/views/desktop/Layout/locale/zh-CN';
import localePDFlist from '@/views/desktop/PDFlist/locale/zh-CN';
import localePPTedit from '@/views/desktop/PPTedit/locale/zh-CN';
import localePPTshare from '@/views/desktop/PPTshare/locale/zh-CN';
export default {
    'Model.addSuccess': '添加成功',
    'Model.LoggedOut': '已退出登录',
    'Delete': '删除',
    'Delete.Success': '删除成功',
    'Share.model.title': '分享演讲',
    'Share.model.btntext': '复制链接',
    'Share.model.closedtitle': '分享链接已关闭',
    'Share.model.opendtitle': '分享链接已开启',
    'Share.model.stitle1': '只有作者有权访问此文档',
    'Share.model.stitle2': '可以通过链接访问互联网',
    'Share.model.copy1': '该链接已被复制，仅供作者访问',
    'Share.model.copy2': '该链接已被复制，可以由在互联网上获得链接的用户查看',
    'Leave.model.title': '提示',
    'Leave.model.content': '检测到有修改未保存，是否保存？',
    'Leave.model.cancelText': '不保存',
    'Leave.model.okText': '保存',
    ...localeSettings,
    ...localeLogin,
    ...localeEmailLogin,
    ...localeLayout,
    ...localePDFlist,
    ...localePPTedit,
    ...localePPTshare,

};
